import { render, staticRenderFns } from "./fabric-segments.vue?vue&type=template&id=d080fd0c&scoped=true"
import script from "./fabric-segments.vue?vue&type=script&lang=js"
export * from "./fabric-segments.vue?vue&type=script&lang=js"
import style0 from "./fabric-segments.vue?vue&type=style&index=0&id=d080fd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d080fd0c",
  null
  
)

export default component.exports